import React, { useState } from "react";

const NavDropdown = ({ title, subItems, isMobileMenu = false, onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasSubItems = Boolean(subItems?.length);

  return (
    <div
      className="nav-dropdown"
      onMouseEnter={() => !isMobileMenu && setIsOpen(true)}
      onMouseLeave={() => !isMobileMenu && setIsOpen(false)}
    >
      <button
        className="dropdown-title"
        type="button"
        aria-expanded={hasSubItems && isOpen}
        onClick={
          isMobileMenu && hasSubItems
            ? () => setIsOpen((open) => !open)
            : undefined
        }
      >
        {title}{" "}
        {hasSubItems && (
          <span className="dropdown-chevron" aria-hidden="true" />
        )}
      </button>

      {hasSubItems && (
        <ul
          className={`dropdown-menu${isOpen ? " is-open" : ""}`}
          aria-hidden={!isOpen}
        >
          {subItems.map((item) => (
            <li key={item.label}>
              <a href={item.href} onClick={onNavigate}>
                <span>{item.label}</span>
              </a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default NavDropdown;
